module.exports = __webpack_public_path__ + "img/background_section5-3.8d2652e2.jpg";